import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';

import { formValidate } from 'eventbrite_design_system/utils/form';
import { SocialLogin } from '@eb/social-login-facebook';

import FormSubmitButton from '../FormSubmitButton';
import EmailField from '../EmailField';

import { lookUpValidate as validate } from '../utils';
import { LOOK_UP_FORM, PASSWORD_TOKEN_EXPIRED_MESSAGE } from '../../constants';

class LookUpForm extends React.PureComponent {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        onSubmit: PropTypes.func,
        buttonCTA: EBPropTypes.translation,
        showNotification: PropTypes.func,
        clearNotification: PropTypes.func,
        shouldAnimate: PropTypes.bool,
        socialSSOSettings: PropTypes.shape({
            facebook: PropTypes.object,
            apple: PropTypes.object,
        }),
        onSocialConnectVerified: PropTypes.func,
        onSocialConnectNotAuthorized: PropTypes.func,
        onSocialProviderClick: PropTypes.func,
        onGetStartedClick: PropTypes.func,
        onTermsOfServiceClick: PropTypes.func,
        onComunityGuidelinesClick: PropTypes.func,
        onPrivacyPolicyClick: PropTypes.func,
        /* Props Provided Via ReduxForm */
        submitSucceeded: PropTypes.bool,
        submitFailed: PropTypes.bool,
        submitting: PropTypes.bool,
        fp: PropTypes.bool,
    };

    state = {
        isDisabled: true,
    };

    componentDidMount() {
        const { trackOnPageLoad } = this.props;

        //eslint-disable-next-line react/no-did-mount-set-state
        this.setState({ isDisabled: false });

        if (trackOnPageLoad) {
            trackOnPageLoad();
        }
    }

    componentWillReceiveProps({
        submitting,
        submitFailed,
        error,
        invalidPasswordResetToken,
    }) {
        const { showNotification, clearNotification } = this.props;

        /*If the form has an error and submit failed, attempt
        to display a notification*/
        if (submitFailed && error) {
            showNotification(error);
        }

        /*We want to limit only one error notification to
        appear per form submission if the user has dismissed it.
        So each time submitting is true, then reset the flag.*/
        if (submitting) {
            clearNotification();
        }

        if (
            !this.props.invalidPasswordResetToken &&
            invalidPasswordResetToken
        ) {
            showNotification(PASSWORD_TOKEN_EXPIRED_MESSAGE);
        }
    }

    componentWillUnmount() {
        const { clearNotification } = this.props;

        clearNotification();
    }

    render() {
        const {
            handleSubmit,
            submitting,
            buttonCTA,
            hideSocialLogin,
            shouldAnimate,
            submitFailed,
            socialSSOSettings,
            onSocialConnectVerified,
            onSocialConnectNotAuthorized,
            onSocialProviderClick,
            onGetStartedClick,
            onTermsOfServiceClick,
            onComunityGuidelinesClick,
            onPrivacyPolicyClick,
            fp,
        } = this.props;

        const { isDisabled } = this.state;

        const emailFieldClasses = 'eds-l-mar-bot-6';

        const buttonClasses = classNames({
            'eds-fx--fade-in-up eds-fx--delay-1': shouldAnimate,
        });

        const isSubmitDisabled = submitting || isDisabled;

        let formComponent = (
            <SocialLogin
                onSocialConnectVerified={onSocialConnectVerified}
                onSocialConnectNotAuthorized={onSocialConnectNotAuthorized}
                socialSSOSettings={socialSSOSettings}
                onSocialProviderClick={onSocialProviderClick}
                onTermsOfServiceClick={onTermsOfServiceClick}
                onComunityGuidelinesClick={onComunityGuidelinesClick}
                onPrivacyPolicyClick={onPrivacyPolicyClick}
                fp={fp}
            >
                <form onSubmit={handleSubmit} noValidate="novalidate">
                    <EmailField
                        submitFailed={submitFailed}
                        buttonClasses={emailFieldClasses}
                        isStatic={true}
                    />
                    <FormSubmitButton
                        buttonClasses={buttonClasses}
                        submitDisabled={isSubmitDisabled}
                        buttonCTA={buttonCTA}
                        onClick={onGetStartedClick}
                    />
                </form>
            </SocialLogin>
        );

        if (hideSocialLogin) {
            formComponent = (
                <form onSubmit={handleSubmit} noValidate="novalidate">
                    <EmailField
                        submitFailed={submitFailed}
                        buttonClasses={emailFieldClasses}
                        isStatic={true}
                    />
                    <FormSubmitButton
                        buttonClasses={buttonClasses}
                        submitDisabled={isSubmitDisabled}
                        buttonCTA={buttonCTA}
                        onClick={onGetStartedClick}
                    />
                </form>
            );
        }

        return formComponent;
    }
}

export default formValidate({
    validate,
    form: LOOK_UP_FORM,
    destroyOnUnmount: false,
    touchOnBlur: false,
})(LookUpForm);
